import PropTypes from 'prop-types';
import React, { forwardRef } from 'react';

import { StyledToggleSwitch } from './styles';

export const ToggleSwitch = forwardRef(
  ({ className, enabled, onChange, ...props }, ref) => (
    <StyledToggleSwitch
      className={className}
      enabled={enabled}
      onClick={onChange}
      ref={ref}
      {...props}
    >
      {enabled ? 'On' : 'Off'}
    </StyledToggleSwitch>
  ),
);

ToggleSwitch.propTypes = {
  className: PropTypes.string,
  enabled: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
};

ToggleSwitch.defaultProps = {
  className: '',
  enabled: false,
};
